import React from "react";
import PropTypes from "prop-types";

import styles from "./style.module.scss";
import logo from "assets/images/logo.svg";

const HamburgerButton = ({ toggleSideBar }: { toggleSideBar: () => void }) => (
  // eslint-disable-next-line react/forbid-elements
  <button
    type="button"
    className="navbar-toggle hamburger-menu-button"
    onClick={toggleSideBar}
    data-testid="side-navigation-toggle"
  >
    <span className="sr-only">Toggle navigation</span>
    <span className="icon-bar" />
    <span className="icon-bar" />
    <span className="icon-bar" />
  </button>
);

const TopNavigation = ({ toggleSideBar }: { toggleSideBar: () => void }) => (
  <div className="row lg:hidden">
    <nav className={`navbar ${styles["top-navigation"]}`} role="navigation">
      <HamburgerButton toggleSideBar={toggleSideBar} />
      <div className={`col-xs-6 ${styles["logo-container"]}`}>
        <img src={logo} className={styles.logo} alt="Tester Work logo" />
      </div>
    </nav>
  </div>
);

TopNavigation.propTypes = {
  toggleSideBar: PropTypes.func,
};

export default TopNavigation;
